export default "__VITE_ASSET__c066e10c__"